import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { GithubSsoLogin } from '../components/scaffolder/GithubSsoLogin';

export const GithubSsoLoginExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubSsoLogin',
    component: GithubSsoLogin,
    schema: {
      returnValue: {
        type: 'object',
      },
      uiOptions: {
        title: 'GitHub Organization',
      },
    },
  }),
);
